import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import Home from '@/views/home/index.vue'
import Loading from '@/views/init/index.vue'
import { useUserStore, useSliderStore } from '@/stores/index'
import { isNeddAuth } from '@/utils/permission/permission-auth'
import { getRouters } from '@/server/menu_request'

// export const constantRoutes = [
// 	{
//     path: '/',
//     name: 'init',
//     component: Loading
//   },
// 	{
//     path: '/loading',
//     name: 'loading',
//     component: () => import('../views/loading/index.vue'),
//     meta: {
//       isAuth: false,
//       authName: ''
//     }
//   },
//   {
//     path: '/login',
//     name: 'login',
//     component: () => import('../views/login/index.vue'),
//     meta: {
//       isAuth: false,
//       authName: ''
//     }
//   },
// {
//   path: '/employee/add/:employeeId',
//   name: 'employeeAdd',
//   component: () => import('../views/add-employee/index.vue'),
//   meta: {
//     isAuth: false,
//     authName: ''
//   }
// },
//   {
//     path: '/login/setting',
//     name: 'loginSetting',
//     component: () => import('../views/loginSetting/index.vue'),
//     meta: {
//       isAuth: false,
//       authName: ''
//     }
//   },
//   {
//     path: '/system/setting',
//     name: 'systemSetting',
//     component: () => import('../views/system-setting/index.vue'),
//     meta: {
//       isAuth: false,
//       authName: ''
//     }
//   },
//   {
//     path: '/hole/setting',
//     name: 'holeSetting',
//     component: () => import('../views/hole-setting/index.vue'),
//     meta: {
//       isAuth: false,
//       authName: ''
//     }
//   },
// ];

// // 动态路由，基于用户权限动态去加载
// export const dynamicRoutes = [
// 	{
//     path: '/home',
//     name: 'home',
//     component: Home,
//     meta: {
//       isAuth: true,
//       authName: 'im:home'
//     }
//   },
//   {
//     path: '/customer',
//     name: 'customer',
//     component: () => import('../views/customer/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:cs'
//     }
//   },
//   {
//     path: '/setting',
//     name: 'setting',
//     component: () => import('../views/setting/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:setting'
//     }
//   },
//   {
//     path: '/check',
//     name: 'check',
//     component: () => import('../views/check/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:check'
//     }
//   },
//   {
//     path: '/checkNew',
//     name: 'checkNew',
//     component: () => import('../views/check/check.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:check'
//     }
//   },
//   {
//     path: '/setting/customer-control',
//     name: 'customerControl',
//     component: () => import('../views/setting/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:employee'
//     }
//   },
//   {
//     path: '/setting/chat/fastReply',
//     name: 'fastReply',
//     component: () => import('../views/fastReply/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:settingother:preference:fastkey'
//     }
//   },
//   {
//     path: '/setting/chat/replace',
//     name: 'replace',
//     component: () => import('../views/wordchange/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:setting:sensitive'
//     }
//   },
//   {
//     path: '/gamein',
//     name: 'gamein',
//     component: () => import('../views/game/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:merchant'
//     }
//   },
//   {
//     path: '/game/rule/:id',
//     name: 'gameRule',
//     component: () => import('../views/gamerule/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:merchant:distribute'
//     }
//   },
//   {
//     path: '/user/game/:id',
//     name: 'gameUser',
//     component: () => import('../views/gamerule/user.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:merchant:users'
//     }
//   },
//   {
//     path: '/account/allocation',
//     name: 'AccountAllocation',
//     component: () => import('../views/account-allocation/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:setting:thirdapp'
//     }
//   },
//   {
//     path: '/addressbook',
//     name: 'AddressBook',
//     component: () => import('../views/address-book/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:addressbook'
//     }
//   },
//   {
//     path: '/role',
//     name: 'ROLE',
//     component: () => import('../views/role-control/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:setting:role'
//     }
//   },
//   {
//     path: '/customer/control',
//     name: 'CUSTOMERCONTROL',
//     component: () => import('../views/customer-control/customer-control.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:cs:list'
//     }
//   },
//   {
//     path: '/card',
//     name: 'card',
//     component: () => import('../views/card/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:card'
//     }
//   },
//   {
//     path: '/notice',
//     name: 'notice',
//     component: () => import('../views/notice/index.vue'),
//     meta: {
//       isAuth: true,
//       authName: 'im:notice'
//     }
//   },
// ];
// //创建路由
// const router = createRouter({
// 	history: createWebHistory(),
// 	routes: constantRoutes,
// 	// 刷新时，滚动条位置还原
// 	//scrollBehavior: () => ({ left: 0, top: 0 }),
// 	scrollBehavior(to, from, savedPosition) {
// 		if (savedPosition) {
// 			return savedPosition;
// 		} else {
// 			return { top: 0 };
// 		}
// 	},
// });
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'init',
      // component: Loading
      component: () => import('@/views/init/index.vue')
    },
    //   {
    //     path: '/home',
    //     name: 'home',
    //     component: Home,
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:home'
    //     }
    //   },
    //   {
    //     path: '/appeal-record',
    //     name: 'appeal-record',
    //     component: () => import('../views/appeal-record/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:check'
    //     }
    //   },
    //   {
    //     path: '/statistics',
    //     name: 'statistics',
    //     component: () => import('../views/statistics/index.vue'),
    //     meta: {
    //       isAuth: false,
    //       authName: ''
    //     }
    //   },
    //   {
    //     path: '/sendSms',
    //     name: 'sendSms',
    //     component: () => import('../views/sendMsg/index.vue'),
    //     meta: {
    //       isAuth: false,
    //       authName: ''
    //     }
    //   },
    //   {
    //     path: '/game-ai',
    //     name: 'game-ai',
    //     component: () => import('../views/game-ai/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:check'
    //     }
    //   },
    //   {
    //     path: '/customer',
    //     name: 'customer',
    //     component: () => import('../views/customer/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:cs'
    //     }
    //   },
    //   {
    //     path: '/setting',
    //     name: 'setting',
    //     component: () => import('../views/setting/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:setting'
    //     }
    //   },
    //   {
    //     path: '/check',
    //     name: 'check',
    //     component: () => import('../views/check/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:check'
    //     }
    //   },
    //   {
    //     path: '/checkNew',
    //     name: 'checkNew',
    //     component: () => import('../views/check/check.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:check'
    //     }
    //   },
    //   {
    //     path: '/loading',
    //     name: 'loading',
    //     component: () => import('../views/loading/index.vue'),
    //     meta: {
    //       isAuth: false,
    //       authName: ''
    //     }
    //   },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login/index.vue'),
      meta: {
        isAuth: false,
        authName: ''
      }
    },
    // {
    //   path: '/customer-manager',
    //   name: 'customerManager',
    //   component: () => import('@/views/customer-control/index.vue'),
    //   meta: {
    //     isAuth: true,
    //     authName: 'im:employee'
    //   }
    // },
    // {
    //   path: '/setting/customer-control',
    //   name: 'customerControl',
    //   component: () => import('../views/setting/index.vue'),
    //   meta: {
    //     isAuth: true,
    //     authName: 'im:employee'
    //   }
    // },
    //   {
    //     path: '/setting/chat/fastReply',
    //     name: 'fastReply',
    //     component: () => import('../views/fastReply/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:settingother:preference:fastkey'
    //     }
    //   },
    //   {
    //     path: '/setting/chat/replace',
    //     name: 'replace',
    //     component: () => import('../views/wordchange/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:setting:sensitive'
    //     }
    //   },
    //   {
    //     path: '/gamein',
    //     name: 'gamein',
    //     component: () => import('../views/game/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:merchant'
    //     }
    //   },
    {
      path: '/game/rule/:id',
      name: 'gameRule',
      component: () => import('../views/gamerule/index.vue'),
      meta: {
        isAuth: true,
        authName: 'im:merchant:distribute',
        languageKey: 'GAME.zidingyi'
      }
    },
    {
      path: '/user/game/:id',
      name: 'gameUser',
      component: () => import('../views/gamerule/user.vue'),
      meta: {
        isAuth: true,
        authName: 'im:merchant:users',
        languageKey: 'CHAT.chat_customer'
      }
    },
    {
      path: '/employee/add/:employeeId',
      name: 'employeeAdd',
      component: () => import('../views/add-employee/index.vue'),
      meta: {
        isAuth: false,
        authName: ''
      }
    },
    //   {
    //     path: '/login/setting',
    //     name: 'loginSetting',
    //     component: () => import('../views/loginSetting/index.vue'),
    //     meta: {
    //       isAuth: false,
    //       authName: ''
    //     }
    //   },
    {
      path: '/system/setting',
      name: 'systemSetting',
      component: () => import('../views/system-setting/index.vue'),
      meta: {
        isAuth: false,
        authName: '',
        languageKey: 'SETTING.set_up'
      }
    }
    //   {
    //     path: '/hole/setting',
    //     name: 'holeSetting',
    //     component: () => import('../views/hole-setting/index.vue'),
    //     meta: {
    //       isAuth: false,
    //       authName: ''
    //     }
    //   },
    //   {
    //     path: '/account/allocation',
    //     name: 'AccountAllocation',
    //     component: () => import('../views/account-allocation/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:setting:thirdapp'
    //     }
    //   },
    //   {
    //     path: '/addressbook',
    //     name: 'AddressBook',
    //     component: () => import('../views/address-book/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:addressbook'
    //     }
    //   },
    //   {
    //     path: '/role',
    //     name: 'ROLE',
    //     component: () => import('../views/role-control/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:setting:role'
    //     }
    //   },
    //   {
    //     path: '/dictionary',
    //     name: 'DICTIONARY',
    //     component: () => import('../views/dictionary/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:setting:sensitive'
    //     }
    //   },
    //   {
    //     path: '/customer/control',
    //     name: 'CUSTOMERCONTROL',
    //     component: () => import('../views/customer-control/customer-control.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:cs:list'
    //     }
    //   },
    //   {
    //     path: '/card',
    //     name: 'card',
    //     component: () => import('../views/card/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:card'
    //     }
    //   },
    //   {
    //     path: '/notice',
    //     name: 'notice',
    //     component: () => import('../views/notice/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:notice'
    //     }
    //   },
    //   {
    //     path: '/rcs',
    //     name: 'rcs',
    //     component: () => import('../views/rcs/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       authName: 'im:send:all'
    //     }
    //   },
    // {
    //   path: '/menu',
    //   name: 'menu',
    //   component: () => import('../views/menu/index.vue'),
    //   meta: {
    //     isAuth: true,
    //     // authName: 'im:menu'
    //     authName: 'im:send:all'
    //   }
    // }
    //   {
    //     path: '/rolemanage',
    //     name: 'rolemanage',
    //     component: () => import('../views/role/index.vue'),
    //     meta: {
    //       isAuth: true,
    //       // authName: 'im:menu'
    //       authName: 'im:send:all'
    //     }
    //   }
  ]
})

/**
 * 不需要校验的路由
 */
export const NONEEDLOGIN = ['/login']

//增加路由前站
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  if (!userStore.token && to.path !== '/login') {
    next('/login')
  } else if (to.path == '/login' && userStore.token) {
    next('/loading')
  } else if (from.path == '/customer' && userStore.token) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    // |ipad
    // alert(from.path)
    let flag = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
    if (flag && !userStore.clickBtnOut) {
      next('/login')
      userStore.loginOut()
    } else {
      useSliderStore().setNavTitle(to.meta?.languageKey ?? '')
      localStorage.setItem('routerpath', JSON.stringify({ to: to }))
      isNeddAuth(to, from, next)
    }
    userStore.setClickBtnOut(false)
  } else {
    useSliderStore().setNavTitle(to.meta?.languageKey ?? '')
    const parentRoute = to.matched[to.matched.length - 2] // 获取父级路由
    if (parentRoute) {
      useSliderStore().setNavParTitle(parentRoute.meta?.languageKey ?? '')
    } else {
      useSliderStore().setNavParTitle('')
    }
    localStorage.setItem('routerpath', JSON.stringify({ to: to }))
    isNeddAuth(to, from, next)
  }
})

let routerRoute: any[] = []
// const getRoutersList = () => {
//   getRouters().then((res: any) => {
//     routerRoute = res?.data ?? []
//   })
// }

let modules = import.meta.glob('../views/**/**.vue')
export async function setupRoutes() {
  if (!useUserStore().token) {
    return
  }
  await getRouters().then((res: any) => {
    routerRoute = res?.data ?? []
    // 设置sildata
    useSliderStore().setRouterList(routerRoute)
    // const dynamicRoutes = routerRoute
    // dynamicRoutes.forEach((route: any) => {
    //   router.addRoute({
    //     path: route.path,
    //     name: route.name,
    //     // component: () => import(`../views/${route.component}.vue`),
    //     component: () => modules[`@/views/${route.component}.vue`],
    //     meta: route.meta
    //   })
    // })
    const dynamicRoutes2 = processRoutes(routerRoute)
    dynamicRoutes2.forEach((route: any) => {
      router.addRoute(route)
    })
    useSliderStore().setRoutes(dynamicRoutes2)
  })
}
function processRoutes(routeData: any) {
  return routeData.map((route: any) => {
    // if (route.component === "Layout") {
    //   route.component = Layout;
    // } else if (route.component === "ParentView") {
    //   route.component = ParentView;
    // } else if (route.component === "InnerLink") {
    //   route.component = InnerLink;
    // } else {
    // route.component = loadView(route.component)
    // }
    let processedRoute = {}
    // if (route.component !== 'Layout') {
    route.meta.isAuth = true
    route.meta.authName = route.meta.perms
    route.meta.hidden = route.hidden
    route.meta.languageKey = route.meta.languageKey ? route.meta.languageKey : ''
    // let modules1 = import.meta.glob('../views/**/*.vue')
    // console.log(route.component, 'route.component')
    processedRoute = {
      path: route.path,
      name: route.name,
      component: loadComponent(route.component),
      // component: modules1[`../views/${route.component}.vue`],
      meta: route.meta || {}
    }
    // }
    if (route.children && route.children.length > 0) {
      processedRoute.children = processRoutes(route.children)
    }
    return processedRoute
  })
}

function loadComponent(componentName: any) {
  return modules[`../views/${componentName}.vue`]
}
// setupRoutes()
export default router
